import React from 'react';
import { FormField as FormFieldType, FormData, FormFiles, FormErrors, GenericFieldType } from '../../../../types/ContactForm';
import { FormField } from '../FormField';
import { CaptchaField } from '../CaptchaField';
import './FormContainer.scss';

interface FormContainerProps {
  fields: FormFieldType[];
  formData: FormData;
  files: FormFiles;
  errors: FormErrors;
  genericFieldValues?: Partial<Record<GenericFieldType, string>>;
  onInputChange: (name: string, value: string) => void;
  onFileChange: (name: string, file: File | File[] | null) => void;
  onFieldFocus: (fieldName: string) => void;
  inputCssClass?: string;
  showCaptcha?: boolean;
  captcha?: {
    num1: number;
    num2: number;
    result: string;
  };
  onCaptchaChange?: (result: string) => void;
  captchaType?: string;
  apiUrl?: string;
  onRecaptchaReady?: (ready: boolean) => void;
  onRecaptchaWidgetId?: (widgetId: number) => void;
  sessionRecaptchaConsent?: boolean;
}

export const FormContainer: React.FC<FormContainerProps> = ({
  fields,
  formData,
  files,
  errors,
  genericFieldValues,
  onInputChange,
  onFileChange,
  onFieldFocus,
  inputCssClass,
  showCaptcha,
  captcha,
  onCaptchaChange,
  captchaType,
  apiUrl,
  onRecaptchaReady,
  onRecaptchaWidgetId,
  sessionRecaptchaConsent
}) => {
  return (
    <div 
      className="contact-form jtl-validate label-slide"
      role="group"
      aria-labelledby="form-fields-group"
    >
      <div 
        id="form-fields-group"
        className="fields"
        role="group"
        aria-label="Formularfelder"
      >
        {fields.map((field) => (
          <div
            key={field.id}
            className="fieldWrapper"
            style={{ '--field-width': `${field.width}%` } as React.CSSProperties}
          >
            <FormField
              field={field}
              formData={formData}
              files={files}
              errors={errors}
              genericFieldValues={genericFieldValues}
              onInputChange={onInputChange}
              onFileChange={onFileChange}
              onFieldFocus={onFieldFocus}
              maxFileSize={field.maxFileSize || 5}
              inputCssClass={inputCssClass}
            />
          </div>
        ))}
        
        {showCaptcha && captcha && onCaptchaChange && (
          <div className="fieldWrapper" style={{ '--field-width': '100%' } as React.CSSProperties}>
            <CaptchaField
              captcha={captcha}
              errors={errors}
              onCaptchaChange={onCaptchaChange}
              captchaType={captchaType}
              apiUrl={apiUrl}
              onRecaptchaReady={onRecaptchaReady}
              onRecaptchaWidgetId={onRecaptchaWidgetId}
              sessionRecaptchaConsent={sessionRecaptchaConsent}
            />
          </div>
        )}
      </div>
    </div>
  );
}; 